import Cookies from 'universal-cookie';
// import { initialize } from 'react-localize-redux';

export default function initLocale() {

    // const languages = [
    //     { name: 'French', code: 'fr' },
    //     { name: 'English', code: 'en' },
    // ];

    const cookies = new Cookies()
    let locale = cookies.get('locale')

    if ( locale === undefined) {
        // check the borweer language
        locale = navigator.language || navigator.userLanguage
        locale = locale.substring(0,2)
    }
    
    // if doesn't match actives languages set EN to default  
    if( locale !== 'en' && locale !== 'fr' ) locale = 'en'

    cookies.set('locale', locale )
    
    // console.log( locale )

    return locale
}



// WEBPACK FOOTER //
// ./src/etc/localize.js